<template>
    <div>

    </div>
</template>

<script>

    export default {
        data() {
            return {
                headerNavCategoryTop: 0,
                placeholderHeight: 0,
                portalDisabled: true,
                showNav: true,
                sliderElement: null,
                showSlideNav: true,
                slideNavLeft: true,
                slideNavRight: true,
            };
        },
        mounted() {
            this.$nextTick(() => {
                if (!document.getElementById('js_subcategoryNav')) {
                    return;
                }
                this.headerNavCategoryTop = document.getElementById('js_subcategoryNav')
                                                    .getBoundingClientRect().top + window.scrollY;
                this.placeholderHeight    = document.getElementById('js_subcategoryNav').getBoundingClientRect().height;
            });

            window.addEventListener('scroll', this.handleScrollEvent);

            window.EventBus.$on('search-opened', () => {
                this.showNav = false;
            });
            window.EventBus.$on('search-closed', () => {
                this.showNav = true;
            });

            this.handleScrollEvent()
            this.initSlider();
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScrollEvent);
        },
        methods: {
            initSlider() {
                if (!this.$refs.slider) return;

                $(this.$refs.slider).slick({
                    arrows: false,
                    variableWidth: true,
                    infinite: false,
                    swipe: true,
                });

                this.setSlideState(0, 7);

                $(this.$refs.slider).on('afterChange', (event, slick, currentSlide) => {
                    this.setSlideState(currentSlide, slick.slideCount)
                });

                const slidesWidthTotal = [...this.$refs.slider.querySelectorAll('.slick-slide')].map(element => element.getBoundingClientRect().width)
                                                                                                .reduce((a, b) => a + b, 0);
                const sliderWidth      = this.$refs.slider.getBoundingClientRect().width;

                this.showSlideNav = slidesWidthTotal >= sliderWidth;

                if (slidesWidthTotal < sliderWidth) {
                    $(this.$refs.slider).slick('slickSetOption', 'swipe', false);
                }

                this.sliderElement = this.$refs.slider;
            },
            setSlideState(currentSlide, slideCount) {
                if (currentSlide === 0) {
                    this.slideNavLeft = false;
                } else if (currentSlide === (slideCount - 1)) {
                    this.slideNavRight = false;
                } else {
                    this.slideNavLeft = true;
                    this.slideNavRight = true;
                }
            },
            slidePrevious() {
                if (!this.sliderElement) return;

                const currentSlide = $(this.sliderElement).slick('slickCurrentSlide');

                $(this.sliderElement).slick('slickGoTo', currentSlide - 4);
            },
            slideNext() {
                if (!this.sliderElement) return;

                const currentSlide = $(this.sliderElement).slick('slickCurrentSlide');

                $(this.sliderElement).slick('slickGoTo', currentSlide + 4);
            },
            handleScrollEvent(event) {
                if (!this.showNav) {
                    return;
                }

                if (window.scrollY > this.headerNavCategoryTop && this.portalDisabled === true) {
                    this.portalDisabled = false;
                } else if (window.scrollY <= this.headerNavCategoryTop && this.portalDisabled === false) {
                    this.portalDisabled = true;
                }
            },
            goToAnchor(anchor) {
                const selector = '#product-category-anchor--' + anchor;
                const offset   = document.querySelector('.brekz-header').offsetHeight;

                if ($(selector).length) {
                    $('html, body').animate({
                        scrollTop: $(selector).offset().top - offset
                    }, 1200);

                    return;
                }

                $('html, body').animate({
                    scrollTop: $("#product-category-anchor-mobile--" + anchor).offset().top - offset
                }, 1200);
            }
        },
        computed: {
            showSlideNavLeft() {
                if (! this.showSlideNav) {
                    return false;
                }

                return (this.slideNavLeft);
            },
            showSlideNavRight() {
                if (! this.showSlideNav) {
                    return false;
                }

                return (this.slideNavRight);
            }
        },
        watch: {
            portalDisabled(portalDisabled) {
                this.sliderElement = null;

                this.$nextTick().then(
                    this.$nextTick(() => {
                        // Timout required for transition
                        this.sliderCallback = setTimeout(() => {
                            this.initSlider();
                        }, 300);
                    })
                );
            }
        },
    };
</script>

<style>

</style>
